import {
  RegularBenefitVariant,
  ShippingApplyTo,
} from '../../../../../../../typings'

export const EMPTY_NOMINAL_SHIPPING = {
  type: RegularBenefitVariant.NominalShipping as const,
  value: undefined,
  applyTo: ShippingApplyTo.all,
}
